import React, { useState, useRef } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Upload, CheckCircle, Plus, Trash2, FileSpreadsheet, X } from 'lucide-react';
import { MoujaInfo } from '../../types';
export const GadgetEntryForm: React.FC = () => {
  const {
    user
  } = useAuth();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [khatianPopup, setKhatianPopup] = useState<{
    open: boolean;
    rowIndex: number;
    exceptionKhatians: string;
    unpublishedKhatians: string;
  }>({
    open: false,
    rowIndex: -1,
    exceptionKhatians: '',
    unpublishedKhatians: ''
  });
  const emptyMoujaRow: MoujaInfo = {
    district: '',
    upazila: '',
    mouja: '',
    jlNumber: '',
    khatianStartNo: '',
    khatianEndNo: '',
    totalKhatian: '',
    totalSheet: '',
    remarks: ''
  };
  const [moujaDetails, setMoujaDetails] = useState<MoujaInfo[]>([{
    ...emptyMoujaRow
  }]);
  const handleMoujaChange = (index: number, field: keyof MoujaInfo, value: string) => {
    const updatedDetails = [...moujaDetails];
    updatedDetails[index] = {
      ...updatedDetails[index],
      [field]: value
    };
    if (field === 'khatianStartNo' || field === 'khatianEndNo') {
      const start = parseInt(updatedDetails[index].khatianStartNo);
      const end = parseInt(updatedDetails[index].khatianEndNo);
      if (!isNaN(start) && !isNaN(end) && end >= start) {
        updatedDetails[index].totalKhatian = (end - start + 1).toString();
      }
    }
    setMoujaDetails(updatedDetails);
  };
  const addMoujaRow = () => {
    setMoujaDetails([...moujaDetails, {
      ...emptyMoujaRow
    }]);
  };
  const removeMoujaRow = (index: number) => {
    if (moujaDetails.length > 1) {
      const updatedDetails = [...moujaDetails];
      updatedDetails.splice(index, 1);
      setMoujaDetails(updatedDetails);
    }
  };
  const handleImportXls = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setTimeout(() => {
        setMoujaDetails([...moujaDetails, {
          district: 'জামালপুর',
          upazila: 'জামালপুর সদর',
          mouja: 'কুমারপাড়া',
          jlNumber: '৮৪',
          khatianStartNo: '১',
          khatianEndNo: '৩৭২',
          totalKhatian: '৩৭২',
          totalSheet: '০১',
          remarks: 'আমদানি করা হয়েছে'
        }]);
        if (fileInputRef.current) fileInputRef.current.value = '';
      }, 500);
    }
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setShowSuccess(true);
      setMoujaDetails([{
        ...emptyMoujaRow
      }]);
      setTimeout(() => setShowSuccess(false), 5000);
    }, 1500);
  };
  const openKhatianPopup = (index: number) => {
    setKhatianPopup({
      open: true,
      rowIndex: index,
      exceptionKhatians: (moujaDetails[index] as any).exceptionKhatians || '',
      unpublishedKhatians: (moujaDetails[index] as any).unpublishedKhatians || ''
    });
  };
  const saveKhatianPopup = () => {
    const updatedDetails = [...moujaDetails];
    (updatedDetails[khatianPopup.rowIndex] as any).exceptionKhatians = khatianPopup.exceptionKhatians;
    (updatedDetails[khatianPopup.rowIndex] as any).unpublishedKhatians = khatianPopup.unpublishedKhatians;
    setMoujaDetails(updatedDetails);
    setKhatianPopup({
      open: false,
      rowIndex: -1,
      exceptionKhatians: '',
      unpublishedKhatians: ''
    });
  };
  return <div className="max-w-5xl mx-auto" data-id="element-636">
      <div className="mb-6" data-id="element-637">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-638">
          নতুন গেজেট প্রস্তুতি
        </h1>
        <p className="text-slate-500" data-id="element-639">
          গেজেট প্রকাশনার জন্য মৌজা ও খতিয়ান তথ্য প্রস্তুত করুন
        </p>
      </div>

      {showSuccess && <div className="mb-6 bg-teal-50 border border-teal-200 text-teal-800 px-4 py-3 rounded-md flex items-center" data-id="element-640">
          <CheckCircle className="mr-3 text-teal-500" size={20} data-id="element-641" />
          <div data-id="element-642">
            <p className="font-medium" data-id="element-643">জমাদান সফল</p>
            <p className="text-sm text-teal-700" data-id="element-644">
              আপনার গেজেট ডেটা ডিএস ভূমি মন্ত্রণালয়ে অনুমোদনের জন্য পাঠানো
              হয়েছে।
            </p>
          </div>
        </div>}

      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-645">
        <div className="card p-0 overflow-hidden" data-id="element-646">
          <div className="p-4 border-b border-slate-200 bg-slate-50 flex justify-between items-center" data-id="element-647">
            <h2 className="text-lg font-semibold text-slate-800" data-id="element-648">
              মৌজা ও খতিয়ান তথ্য
            </h2>
            <div data-id="element-649">
              <input type="file" accept=".xls,.xlsx" className="hidden" ref={fileInputRef} onChange={handleImportXls} data-id="element-650" />
              <button type="button" onClick={() => fileInputRef.current?.click()} className="btn-secondary text-sm flex items-center py-1.5 px-3" data-id="element-651">
                <FileSpreadsheet size={16} className="mr-2 text-green-600" data-id="element-652" />
                এক্সেল থেকে আমদানি
              </button>
            </div>
          </div>

          <div className="overflow-x-auto" data-id="element-653">
            <table className="min-w-full divide-y divide-slate-200" data-id="element-654">
              <thead className="bg-slate-100" data-id="element-655">
                <tr data-id="element-656">
                  <th className="px-3 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-657">
                    জেলা
                  </th>
                  <th className="px-3 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-658">
                    উপজেলা
                  </th>
                  <th className="px-3 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-659">
                    মৌজার নাম
                  </th>
                  <th className="px-3 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-660">
                    জে.এল. নম্বর
                  </th>
                  <th className="px-3 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-661">
                    খতিয়ান শুরু নং
                  </th>
                  <th className="px-3 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-662">
                    শেষ নং
                  </th>
                  <th className="px-3 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-663">
                    খতিয়ান সংখ্যা
                  </th>
                  <th className="px-3 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-664">
                    শীট সংখ্যা
                  </th>
                  <th className="px-3 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-665">
                    মন্তব্য
                  </th>
                  <th className="px-3 py-3 text-center text-xs font-medium text-slate-500 uppercase" data-id="element-666">
                    কার্যক্রম
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-slate-200" data-id="element-667">
                {moujaDetails.map((row, index) => <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-slate-50'} data-id="element-668">
                    <td className="px-2 py-2" data-id="element-669">
                      <select required value={row.district} onChange={e => handleMoujaChange(index, 'district', e.target.value)} className="w-full border border-slate-300 rounded px-2 py-1.5 text-sm focus:ring-1 focus:ring-slate-900" data-id="element-670">
                        <option value="" data-id="element-671">নির্বাচন করুন</option>
                        <option value="ঢাকা" data-id="element-672">ঢাকা</option>
                        <option value="গাজীপুর" data-id="element-673">গাজীপুর</option>
                        <option value="জামালপুর" data-id="element-674">জামালপুর</option>
                        <option value="নারায়ণগঞ্জ" data-id="element-675">নারায়ণগঞ্জ</option>
                        <option value="চট্টগ্রাম" data-id="element-676">চট্টগ্রাম</option>
                      </select>
                    </td>
                    <td className="px-2 py-2" data-id="element-677">
                      <select required value={row.upazila} onChange={e => handleMoujaChange(index, 'upazila', e.target.value)} className="w-full border border-slate-300 rounded px-2 py-1.5 text-sm focus:ring-1 focus:ring-slate-900" data-id="element-678">
                        <option value="" data-id="element-679">নির্বাচন করুন</option>
                        <option value="সাভার" data-id="element-680">সাভার</option>
                        <option value="টঙ্গী" data-id="element-681">টঙ্গী</option>
                        <option value="জামালপুর সদর" data-id="element-682">জামালপুর সদর</option>
                        <option value="রূপগঞ্জ" data-id="element-683">রূপগঞ্জ</option>
                        <option value="হাটহাজারী" data-id="element-684">হাটহাজারী</option>
                      </select>
                    </td>
                    <td className="px-2 py-2" data-id="element-685">
                      <input type="text" required value={row.mouja} onChange={e => handleMoujaChange(index, 'mouja', e.target.value)} className="w-full border border-slate-300 rounded px-2 py-1.5 text-sm focus:ring-1 focus:ring-slate-900" placeholder="মৌজা" data-id="element-686" />
                    </td>
                    <td className="px-2 py-2" data-id="element-687">
                      <input type="text" required value={row.jlNumber} onChange={e => handleMoujaChange(index, 'jlNumber', e.target.value)} className="w-20 border border-slate-300 rounded px-2 py-1.5 text-sm focus:ring-1 focus:ring-slate-900" placeholder="জে.এল." data-id="element-688" />
                    </td>
                    <td className="px-2 py-2" data-id="element-689">
                      <input type="text" value={row.khatianStartNo} onChange={e => handleMoujaChange(index, 'khatianStartNo', e.target.value)} className="w-20 border border-slate-300 rounded px-2 py-1.5 text-sm focus:ring-1 focus:ring-slate-900" placeholder="শুরু নং" data-id="element-690" />
                    </td>
                    <td className="px-2 py-2" data-id="element-691">
                      <input type="text" value={row.khatianEndNo} onChange={e => handleMoujaChange(index, 'khatianEndNo', e.target.value)} className="w-20 border border-slate-300 rounded px-2 py-1.5 text-sm focus:ring-1 focus:ring-slate-900" placeholder="শেষ নং" data-id="element-692" />
                    </td>
                    <td className="px-2 py-2" data-id="element-693">
                      <input type="number" required value={row.totalKhatian} onFocus={() => openKhatianPopup(index)} readOnly className="w-24 border border-slate-300 rounded px-2 py-1.5 text-sm focus:ring-1 focus:ring-slate-900 cursor-pointer bg-slate-50" placeholder="খতিয়ান" data-id="element-694" />
                    </td>
                    <td className="px-2 py-2" data-id="element-695">
                      <input type="number" required value={row.totalSheet} onChange={e => handleMoujaChange(index, 'totalSheet', e.target.value)} className="w-24 border border-slate-300 rounded px-2 py-1.5 text-sm focus:ring-1 focus:ring-slate-900" placeholder="শীট" data-id="element-696" />
                    </td>
                    <td className="px-2 py-2" data-id="element-697">
                      <input type="text" value={row.remarks} onChange={e => handleMoujaChange(index, 'remarks', e.target.value)} className="w-full border border-slate-300 rounded px-2 py-1.5 text-sm focus:ring-1 focus:ring-slate-900" placeholder="মন্তব্য" data-id="element-698" />
                    </td>
                    <td className="px-2 py-2 text-center" data-id="element-699">
                      <button type="button" onClick={() => removeMoujaRow(index)} disabled={moujaDetails.length === 1} className={`p-1.5 rounded ${moujaDetails.length === 1 ? 'text-slate-300 cursor-not-allowed' : 'text-red-500 hover:bg-red-50'}`} data-id="element-700">
                        <Trash2 size={16} data-id="element-701" />
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          <div className="p-3 border-t border-slate-200 bg-slate-50" data-id="element-702">
            <button type="button" onClick={addMoujaRow} className="text-sm font-medium text-teal-600 hover:text-teal-800 flex items-center" data-id="element-703">
              <Plus size={16} className="mr-1" data-id="element-704" /> আরও সারি যোগ করুন
            </button>
          </div>
        </div>

        <div className="flex justify-end space-x-4" data-id="element-705">
          <button type="button" className="btn-secondary" data-id="element-706">
            বাতিল
          </button>
          <button type="submit" className="btn-primary flex items-center" disabled={isSubmitting} data-id="element-707">
            {isSubmitting ? <>প্রক্রিয়াকরণ হচ্ছে...</> : <>
                <Upload size={18} className="mr-2" data-id="element-708" />
                জমা দিন
              </>}
          </button>
        </div>
      </form>

      {khatianPopup.open && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-709">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-lg" data-id="element-710">
            <div className="p-4 border-b border-slate-200 flex justify-between items-center bg-slate-50 rounded-t-lg" data-id="element-711">
              <h2 className="text-lg font-bold text-slate-800" data-id="element-712">
                খতিয়ান বিস্তারিত তথ্য
              </h2>
              <button type="button" onClick={() => setKhatianPopup({
            open: false,
            rowIndex: -1,
            exceptionKhatians: '',
            unpublishedKhatians: ''
          })} className="text-slate-400 hover:text-slate-600" data-id="element-713">
                <X size={20} data-id="element-714" />
              </button>
            </div>
            <div className="p-6 space-y-5" data-id="element-715">
              <div data-id="element-716">
                <label className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-717">
                  খতিয়ান সংখ্যা
                </label>
                <input type="number" value={moujaDetails[khatianPopup.rowIndex]?.totalKhatian || ''} onChange={e => handleMoujaChange(khatianPopup.rowIndex, 'totalKhatian', e.target.value)} className="input-field text-sm" placeholder="মোট খতিয়ান সংখ্যা লিখুন" data-id="element-718" />
              </div>
              <div data-id="element-719">
                <label className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-720">
                  ব্যতিক্রম খতিয়ান নম্বর সমূহ
                </label>
                <textarea rows={3} value={khatianPopup.exceptionKhatians} onChange={e => setKhatianPopup({
              ...khatianPopup,
              exceptionKhatians: e.target.value
            })} className="input-field text-sm" placeholder="কমা (,) দিয়ে আলাদা করুন, যেমন: ১২, ৪৫, ৭৮" data-id="element-721" />
                <p className="text-xs text-slate-400 mt-1" data-id="element-722">
                  কমা (,) দিয়ে আলাদা করে খতিয়ান নম্বর লিখুন
                </p>
              </div>
              <div data-id="element-723">
                <label className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-724">
                  প্রকাশিত নয় এমন খতিয়ান নম্বর সমূহ
                </label>
                <textarea rows={3} value={khatianPopup.unpublishedKhatians} onChange={e => setKhatianPopup({
              ...khatianPopup,
              unpublishedKhatians: e.target.value
            })} className="input-field text-sm" placeholder="কমা (,) দিয়ে আলাদা করুন, যেমন: ১০১, ২০৩, ৩৫০" data-id="element-725" />
                <p className="text-xs text-slate-400 mt-1" data-id="element-726">
                  কমা (,) দিয়ে আলাদা করে খতিয়ান নম্বর লিখুন
                </p>
              </div>
            </div>
            <div className="p-4 border-t border-slate-200 bg-slate-50 rounded-b-lg flex justify-end space-x-3" data-id="element-727">
              <button type="button" onClick={() => setKhatianPopup({
            open: false,
            rowIndex: -1,
            exceptionKhatians: '',
            unpublishedKhatians: ''
          })} className="btn-secondary" data-id="element-728">
                বাতিল
              </button>
              <button type="button" onClick={saveKhatianPopup} className="btn-primary" data-id="element-729">
                সংরক্ষণ করুন
              </button>
            </div>
          </div>
        </div>}
    </div>;
};